export const GET_CONSULT_LIST = 'GET_CONSULT_LIST'
export const SET_CONSULT_LIST_LOADING = 'SET_CONSULT_LIST_LOADING'
export const GET_CONSULT_DOCUMENTS = 'GET_CONSULT_DOCUMENTS'
export const SET_CONSULT_DOCS_LOADING = 'SET_CONSULT_DOCS_LOADING'
export const CLEAR_CONSULT = 'CLEAR_CONSULT'
export const RESET_CONSULT_MODAL = 'RESET_CONSULT_MODAL'
